"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var runIos_exports = {};
__export(runIos_exports, {
  run: () => run
});
module.exports = __toCommonJS(runIos_exports);
var import_loadConfig = require("../vite/loadConfig");
async function run(args) {
  var _options_config_config_server, _options_config_config, _options_config;
  var { runIos } = await import("vxrn");
  var options = await (0, import_loadConfig.loadUserOneOptions)("serve", true).catch(function() {
    return null;
  });
  await runIos({
    root: process.cwd(),
    port: options === null || options === void 0 ? void 0 : (_options_config = options.config) === null || _options_config === void 0 ? void 0 : (_options_config_config = _options_config.config) === null || _options_config_config === void 0 ? void 0 : (_options_config_config_server = _options_config_config.server) === null || _options_config_config_server === void 0 ? void 0 : _options_config_config_server.port
  });
}
//# sourceMappingURL=runIos.js.map
